/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactSubscribeRequest {
    getFixupPrototypeFunction() { return ArtifactSubscribeRequest.fixupPrototype; }

    static newInstance(model: Partial<ArtifactSubscribeRequest>): ArtifactSubscribeRequest {
        let obj = Object.assign(new ArtifactSubscribeRequest(), model);
        ArtifactSubscribeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactSubscribeRequest>): ArtifactSubscribeRequest {
        if (!model) return null;
        return ArtifactSubscribeRequest.newInstance(<ArtifactSubscribeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactSubscribeRequest) {
        if (!obj) return;

        models.ArtifactSubscribeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactSubscribeRequest): boolean {
        Object.setPrototypeOf(obj, ArtifactSubscribeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the heatstack schedule created for this artifact (see ScheduleExecutionParameterForAiAgentArtifact)
     */
    schedule_id: string;

}
